import { money } from '../lib/format';

/**
 * Todo dinheiro na tela passa por aqui.
 *
 * A regra e uma so e vale em toda parte: negativo sai vermelho com o menos na
 * frente, positivo sai verde, zero fica neutro. Antes cada tela decidia
 * sozinha, e o mesmo saldo aparecia cinza no painel e vermelho na lista.
 *
 * Ha uma armadilha que justifica o componente existir em vez de uma funcao
 * solta: nem todo campo guarda o sinal. "Fatura de cartao" e "Despesas do
 * mes" chegam como MAGNITUDE positiva, porque o nome do campo ja diz a
 * direcao — sao "quanto voce deve" e "quanto voce gastou", nao "quanto voce
 * tem". Pela regra do sinal os dois sairiam verdes: dinheiro que saiu pintado
 * da cor de dinheiro que entrou.
 *
 * Por isso `saida` existe. O numero guardado continua sendo o que e; o que
 * muda e o que se mostra a quem le.
 */
export function Valor({
  cents,
  saida = false,
  className = '',
}: {
  cents: string;
  /** O campo guarda uma saida como magnitude positiva (divida, gasto do mes). */
  saida?: boolean;
  className?: string;
}) {
  const bruto = BigInt(cents);
  const exibido = saida ? -absoluto(bruto) : bruto;

  return (
    <span className={`money ${classeDoSinal(exibido)} ${className}`.trim()}>
      {money(exibido.toString())}
    </span>
  );
}

/** Negativo vermelho, positivo verde, zero neutro. */
export function classeDoSinal(valor: bigint): string {
  if (valor < 0n) return 'expense';
  if (valor > 0n) return 'income';
  return 'muted';
}

function absoluto(valor: bigint): bigint {
  return valor < 0n ? -valor : valor;
}
